export const DEFAULT_RANGE_DAYS = 3;

export const DEFAULT_MAP_COORDINATES: [number, number] = [49.285625, 31.797635];

export const DEFAULT_ONLINE_MODE_SECONDS_RANGE = [10, 15, 20, 25, 30];

export const DEFAULT_ONLINE_MODE_VIEW_LIMIT_RANGE = [10, 25, 50, 100];

export const DEFAULT_APP_DOCUMENT_TITLE = 'WIM';
